import API from 'services/API';
import { formatAddress } from 'utils';

export default function getTaxAuthorities(parentId) {
  return API.request({
    method: 'GET',
    url: `/appointment/getIfns?parentId=${parentId}`,
    mapper: function (data = []) {
      return data.map((taxAuthority) => {
        return {
          address: formatAddress(taxAuthority.contacts),
          ...taxAuthority,
        };
      });
    },
  });
}
